// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import * as serviceActions from './actions';
import * as serviceSelectors from './selectors';

import * as MessageFormat from './MessageFormat';
import OutcallFormat from './OutcallFormat';
import InboundCallFormat from './InboundCallFormat';
import TextFormat from './TextFormat';
import SmsFormat from './SmsFormat';
import CsFormat from './CsFormat';
import TaskFormat from './TaskFormat';
import VoicemailFormat from './VoicemailFormat';
import AgentFormat from './AgentFormat';
import * as ServiceIcons from './Icons';
import ChatFormat from './ChatFormat';



const styles = theme => ({
  ...MessageFormat.styles(theme),
  popover: {
    '& .MuiPopover-paper':{
      // width:'95vw',
      // maxWidth:'500px',
      // top:'50%',
      // left:'50%',
      // transformOrigin:'center'
    },
  }
});


/*
 * Display a popover when clicking on a message
 */

class ActivityDetail extends Component {

  generatePdfReport = () => {
    this.props.generatePdf("single", this.props.message.messageId);
  }
  
  render() {
    /* eslint-disable */
    const { classes, message, activityDetailOpen,
            setActivityDetailOpen } = this.props;

    /* Pick a format based on type */
    let details;
    
    /* User outcall */
    if (message.messageType === 'OC') {
      details=<OutcallFormat/>
    }
    
    /* Inbound call with no message */
    if (message.messageType === 'IC' || message.messageType === 'VIP') {
      details=<InboundCallFormat/>
    }
    
    /* Internal Text */
    if (message.messageType === 'TEXT') {
      details=<TextFormat/>
    }

    /* SMS */
    if (message.messageType === 'SMS') {
      details=<SmsFormat/>
    }

    /* CHAT */
    if (message.messageType === 'CHAT') {
      details=<ChatFormat/>
    }
    
    /* Voicemail */
    if (message.messageType === 'VM') {
      details=<VoicemailFormat/>
    }
    
    /* CS initiated task */
    if (message.messageType === 'CS') {
      details=<CsFormat/>
    }
    
    /* Task initiated task */
    if (message.messageType === 'TASK') {
      details=<TaskFormat/>
    }
      
    /* Agent taken message */
    if (message.messageType === 'AGENT' || message.messageType === 'AGENT+VM') {
      details=<AgentFormat/>
    }
      
    if (typeof(details) === 'undefined') {
      details=<div>
        Unknown Message Type: {message.messageId} {message.messageType}
      </div>;
    }
    return (
      <MuiCore.Popover
      className={classes.popover} 
      open={activityDetailOpen}
                       onClose={() => setActivityDetailOpen(false)}
                      //  className={classes.popover}
                       transformOrigin = {{
                         horizontal : 'center',
                         vertical : 'center',
                       }}
                       anchorOrigin={{ horizontal: 'center',
                                       vertical: 'center'}}>
        <div className={classes.root}>
          <div className={classes.topBar}>
            <div className={classes.raisedIcon}>
              {ServiceIcons.IconForType(message)}
            </div>
            {/* <div style={{ flexGrow: 1 }}>
            </div> */}
            <div>
              <MuiCore.IconButton onClick={() => setActivityDetailOpen(false)}>
                <CloseIcon/>
              </MuiCore.IconButton>
            </div>
          </div>
          <div className={classes.detailArea}>
            {details}
          </div>
          {/* <div style={{ width: '100%', textAlign: 'center'}}>
            <MuiCore.Button style={{ marginTop: 10, fontSize: 12, height: 30, width: '15em'}}
              onClick={this.generatePdfReport}>
              Generate PDF Report
            </MuiCore.Button>   
          </div> */}
        </div>
      </MuiCore.Popover>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    activityDetailOpen : serviceSelectors.getActivityDetailOpen(state),
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  generatePdf: serviceActions.generatePdfReport
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ActivityDetail));

